import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/net-interest-margin-calculator',
  component: () => import('../../routes/NetInterestMarginCalculator.svelte'),
  card: {
    id: 'net-interest-margin-calculator',
    title: 'Net Interest Margin Calculator',
    description:
      'Calculate NIM for banks and credit unions. Measures how effectively a financial institution converts earning assets into net interest income.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/net-interest-margin-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Net Interest Margin Calculator – NIM Formula & Interpretation',
    description:
      'Free Net Interest Margin calculator. Calculate NIM = (Interest Income − Interest Expense) / Average Earning Assets × 100. Understand your financial institution\'s profitability.',
  },
};

export default meta;